import { createFileRoute } from '@tanstack/react-router';
import PreviewPage from '@/features/resume-builder/preview';

/** EU-762 RN-26..28 — "Prévia do currículo". */
export const Route = createFileRoute('/modulos/$moduleId_/curriculo/previa')({
  component: PreviewPage,
});
